import { useContext, useRef, useState } from 'react';
import { deleteSavedPrompts } from '../../services/savedPrompts';

import { Button } from 'react-bootstrap';
import SaveTopicIcon from '../../assets/icon-google-topic.svg?react';
import DeleteIcon from '../../assets/icon-google-delete.svg?react';
import TickIcon from '../../assets/icon-google-tick.svg?react';
import { LoadingContext } from '../../context/LoadingContext';
import OverlayTooltip from '../common/UI/OverlayTooltip';
import useElysiaStore from '@/app/elysia-store';

export const SavedPromptButton = (props) => {
  const { topic, index, setSavedTopics, handleClose } = props;
  const [deletedPromptId, setDeletedPromptId] = useState<number | null>(null);
  const [showBadge, setShowBadge] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const { isLoading } = useContext(LoadingContext);
  const setPromptInput = useElysiaStore.getState().setPromptInput;

  const startNewSavedPromptChat = (promptValue) => {
    setPromptInput(promptValue);
    handleClose();
  };

  const handleDeleteSavedPrompts = async (promptId: number) => {
    try {
      const response = await deleteSavedPrompts(promptId);
      if (response) {
        setDeletedPromptId(promptId);
        setShowBadge(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          setDeletedPromptId(null);
          setShowBadge(false);
          setSavedTopics((prevTopics) =>
            prevTopics.filter((topic) => topic.prompt_id !== promptId)
          );
        }, 2000);
      }
    } catch (err) {
      console.error('error while deleting the saved prompt', err);
    }
  };

  return (
    <>
      <Button
        disabled={isLoading}
        className="saved-prompt-topic"
        key={index}
        variant="none"
        onClick={() => {
          startNewSavedPromptChat(topic.prompt);
        }}
      >
        <div className="d-flex mb-2 saved-prompt-text-container">
          <SaveTopicIcon className="save-topic-icon" />
          <div className="ms-2 saved-topic-text">{topic?.prompt}</div>
        </div>
        <div className="delete-saved-topic">
          <OverlayTooltip
            tooltipText="Delete"
            buttonContent={<DeleteIcon />}
            ariaLabel="delete saved prompt"
            testId="delete-saved-prompt-button"
            tooltipClassName="save-prompt-tooltip"
            buttonClassName="delete-saved-topic-icon"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteSavedPrompts(topic.prompt_id);
            }}
            placement="bottom"
            disabled={deletedPromptId === topic.prompt_id}
          />
        </div>
        {showBadge && (
          <span className="history-badge-delete-prompt-button">
            <TickIcon />
            <span>Deleted</span>
          </span>
        )}
      </Button>
    </>
  );
};
